import { HttpClient, HttpStatusCode } from '@/javascript/data/protocols/http'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { LoadWorkLocationList } from '@/javascript/domain/usecases/maps/load-work-location-list'
import { ListMapper } from '@/javascript/infra/mappers/mapper'
import { RemoteWorkLocation } from '@/javascript/data/entities/maps/remote-work-location'
import { WorkLocation } from '@/javascript/domain/entities/maps/work-location'

export class RemoteLoadWorkLocationList implements LoadWorkLocationList {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadWorkLocationList.Response>,
    private readonly workLocationMapper: ListMapper<WorkLocation, RemoteWorkLocation>
  ) {}

  async load(params?: LoadWorkLocationList.Params): Promise<WorkLocation[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params: {
        date: params?.date?.toISOString(),
        q: params?.searchText,
        resource_place_ids: params?.resourcePlaces,
        form_ids: params?.forms,
        project_ids: params?.projects,
        provider_ids: params?.providers,
        inspector_ids: params?.inspectors,
        status: params?.status,
        work_finish_option_ids: params?.finishOptions
      }
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok: return this.workLocationMapper.toEntityList(response?.work_locations) ?? []
      case HttpStatusCode.noContent: return []
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadWorkLocationList {
  export type Response = {
    work_locations?: RemoteWorkLocation[]
  }
}
